import Vue from "vue"
import "./plugins/vuetify"
import App from "./App.vue"
import VueJWT from "vuejs-jwt"
import router from "./router"
import { createProvider } from "./vue-apollo"

Vue.config.productionTip = false
Vue.use(VueJWT, { keyName: "apollo-token" })

new Vue({
    router,
    apolloProvider: createProvider(),
    render: h => h(App)
}).$mount("#app")
